import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { className: "path", cx: 25, cy: 25, r: 24.5, fill: "none", strokeWidth: 1 }));
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
